import { Method } from './enums/method';
import type { IHttpClient } from './interfaces/i-http-client';

/**
 * HTTPClient for communicataion to android.
 * @implements IHttpClient
 */
export class AndroidHttpClient implements IHttpClient {
	/**
	 * Set up and send a GET request to the android native part
	 * @param url - string
	 * @returns Promise\<any\>
	 */
	public async get(url: string): Promise<any> {
		if (!this.validateUrl(url)) {
			throw new Error('Invalid URL');
		}

		return await new Promise((resolve, reject) => {
			const request = this.createRequest(Method.GET, url, resolve, reject);
			request.send();
		});
	}

	/**
	 * Set up and send a POST request to the android native part
	 * @param url - string
	 * @param body - any
	 * @returns Promise\<any\>
	 */
	public async post(url: string, body = undefined): Promise<any> {
		if (!this.validateUrl(url)) {
			throw new Error('Invalid URL');
		}

		return await new Promise((resolve, reject) => {
			const request = this.createRequest(Method.POST, url, resolve, reject);
			request.send(body);
		});
	}

	/**
	 * @emits NOTE: Throws not implemented exception!
	 *
	 * Set up and send a PUT request to the android native part
	 * @param path - string
	 * @param options
	 */
	public async put(path: string, options?: RequestInit): Promise<any> {
		throw new Error('Method not implemented.');
	}

	/**
	 * @emits NOTE: Throws not implemented exception!
	 *
	 * Set up and send a DELETE request to the android native part
	 * @param path - string
	 * @param options
	 */
	public async delete(path: string, options?: RequestInit): Promise<any> {
		throw new Error('Method not implemented.');
	}

	/**
	 * Create new XMLHTTPRequet without sending it.
	 * @param method - Method
	 * @param url - string
	 * @param resolve - Promise.resolve
	 * @param reject - Promise.resolve
	 * @returns XMLHTTPRequest
	 */
	private createRequest(
		method: Method,
		url: string,
		resolve: (value: any) => void,
		reject: (reason?: any) => void,
	) {
		const request = new XMLHttpRequest();

		request.open(method, url);
		request.onload = () => {
			// TODO(aavramov): right now its data.data. Check if we can simplify when we get to stage of implementation
			let responseData;
			try {
				responseData = JSON.parse(request.response);
			} catch (error) {
				responseData = request.response || request.responseText;
			}
			resolve({ data: responseData });
		};
		request.onerror = () => {
			reject(request.responseText);
		};
		return request;
	}

	/**
	 *
	 * @param path - string
	 * @returns boolean
	 */
	private validateUrl(path: string): boolean {
		return path.startsWith('shelly://');
	}
}
